import { ItemDataService } from "data/service/item-data-service";
import { Item, ItemType } from "data/entities/entities";
import { autoinject, LogManager } from 'aurelia-framework';

@autoinject()
export class Projects {

    constructor(private itemDataService: ItemDataService) {
        
    }

	logger = LogManager.getLogger("Boards")

    projects:Array<Item> = [];

    activate() {
        if (!this.dataIsInitialized) {
            this.initializeData();
        }
    }

    async initializeData() {
		try {
			this.projects = await this.itemDataService.findWithCriteria({ itemTypeId: 2 });
		}
		catch (error) {
			
		}
    }

    dataIsInitialized;
}